import { productTreeContainer } from '../../product-family-container/product-family-container.styles';
import {
  appContainer,
  appIconStyle,
  appLogoNameContainer,
  appNameStyle,
  appPricingContainer,
  appWrapperContainer,
  errorMessageStyle
} from './app-card.styles';
import { appLogo } from './app-logo';
import { removeButtonStyle } from '../../product-family-container/pricing.styles';
import { useGlobalStore } from '../../../store';
import { useModuleProps } from '../../../module-props';

export interface AppErrorCardProps {
  appName: string;
  errorMessage: string;
}

const AppErrorCard = (props: AppErrorCardProps) => {
  const { appName, errorMessage } = props;

  const [_, { removeAppError }] = useGlobalStore();
  const {
    appLabel,
    removeLabel,
    appCardUnexpectedError,
    appCardPricingDataMissingError
  } = useModuleProps();

  const dismiss = () => {
    removeAppError(appName);
  };

  let errorMessageDisplay = appCardUnexpectedError;
  if (errorMessage.includes('Found neither monthly or annual')) {
    errorMessageDisplay = appCardPricingDataMissingError;
  }

  return (
    <div css={productTreeContainer} data-testid="marketplace-app-error-card">
      <div css={appWrapperContainer}>
        <div css={appContainer}>
          <div css={appLogoNameContainer}>
            <div css={appIconStyle}>{appLogo}</div>
            <div style={{ display: 'block' }}>
              <div css={appNameStyle}>
                {appLabel}: {appName}
              </div>
              <div css={errorMessageStyle}>{errorMessageDisplay}</div>
            </div>
          </div>
        </div>
        <div css={appPricingContainer}>
          <button css={removeButtonStyle} onClick={dismiss}>
            {removeLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppErrorCard;
